import { jsx as _jsx } from "react/jsx-runtime";
import { HcTag } from '@hotmart-org-ca/cosmos-web/dist/react/hc-tag';
export function Tag({ children, context, size = 'medium', variation = 'primary', style }) {
    return (_jsx(HcTag, { slot: "tag", size: size, style: style, context: context, variation: variation, className: "whitespace-nowrap", children: children }));
}
